<template>
    <div class="aba-produto">
        <div class="vertical-flow">
            <div class="columns">
                <div
                    class="column"
                    :class="[
                        permissaoVincular && permissaoCadastrar
                            ? 'is-4'
                            : permissaoVincular || permissaoCadastrar
                            ? 'is-6'
                            : 'is-8',
                    ]"
                >
                    <search-bar
                        :onSearch="debouncedOnSearch"
                        tooltipLabel="msg-busca-agro-ass-produto"
                    />
                </div>

                <div
                    class="column situacao-select"
                    :class="[
                        permissaoVincular && permissaoCadastrar
                            ? 'is-2'
                            : permissaoVincular || permissaoCadastrar
                            ? 'is-3'
                            : 'is-4',
                    ]"
                >
                    <vss-select
                        ref="situacaoInput"
                        title="situacao"
                        :options="situacoes"
                        :mlLabels="true"
                        @input="onSituacaoChanged"
                        v-model="situacao"
                        :height="40"
                        :clearable="true"
                    />
                </div>

                <div class="column is-3" v-if="permissaoVincular">
                    <button class="save-btn botao-acao" type="button" @click="showModalVincular">
                        {{ $t('vincular-produto') }}
                    </button>
                </div>
                <!-- Botao vai para a tela de cadastro de produto, e a função para 
                voltar para a tela atual está na OcorrenciaManage e Geral de produto -->
                <div class="column is-3" v-if="permissaoCadastrar">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="
                            $router.push({
                                name: 'ven-produto-new',
                                query: { tela: `${abrev}-ocorrencia-edit`, id: $route.params.id },
                            })
                        "
                    >
                        {{ $t('adicionar-produto') }}
                    </button>
                </div>
            </div>

            <div class="registry-wrapper">
                <container-loader v-if="isLoading && !$store.getters.isLoading" />
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="assocorrenciaproduto"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.key) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.key == 'excluir',
                        }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'excluir'">
                            <span v-if="permissao.update && !assIntegracao">
                                <b-button
                                    class="action-button"
                                    :type="props.row['situacao'] == 1 ? 'is-danger' : 'is-success'"
                                    :icon-right="props.row['situacao'] == 1 ? 'delete' : 'check'"
                                    @click="promptChangeSituacao(props.row)"
                                    v-tippy
                                    :title="
                                        $t(props.row['situacao'] == 1 ? 'desativar' : 'reativar')
                                    "
                                />
                            </span>
                        </div>
                        <div v-else-if="f.key == 'situacao'">
                            <b-tag
                                class="table-tag table-tag-full-width"
                                v-if="props.row['situacao'] == 1"
                                type="is-success"
                                size="is-medium"
                                >{{ $t('ativo') }}</b-tag
                            >
                            <b-tag
                                class="table-tag table-tag-full-width"
                                v-else
                                type="is-danger"
                                size="is-medium"
                                >{{ $t('inativo') }}</b-tag
                            >
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>

            <!-- MODAL DE ASSOCIACAO -->
            <b-modal :active.sync="showModalAssociacao">
                <div class="bg">
                    <AssProdutoModal :idCliente="$route.params.id" @fecharModal="fecharModal" />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
// SERVICES
import AssService from '@/services/agro/ocorrencia/AssOcorrenciaProdutoService';
import AssProdutoModal from '@/components/agro/ocorrencia/modal/AssProdutoModal.vue' 
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    components: {
        ContainerLoader,
        AssProdutoModal,
    },
    data() {
        return {
            assIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'AGRO_ASSOCORRENCIAPRODUTO'
            ),
            integracao: this.$store.state.user.tabelasERPWebServer.includes('AGRO_OCORRENCIA'),
            produtoIntegracao: this.$store.state.user.tabelasERPWebServer.includes('PRODUTO'),
            assocorrenciaproduto: [],
            fields: [
                { key: 'codigo', width: null, sortable: true, sortFn: null },
                { key: 'produto', width: null, sortable: true, sortFn: null },
                { key: 'familia', width: null, sortable: true, sortFn: null },
                { key: 'situacao', width: 80, sortable: true, sortFn: null },
                { key: 'excluir', width: 20, sortable: false, sortFn: null },
            ],

            service: new AssService(this.$http, this.$router),
            permissao: false,
            permissaoProduto: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            situacao: { id: 2, label: 'todos' },
            situacoes: [
                { id: 2, label: 'todos' },
                { id: 1, label: 'ativos' },
                { id: 0, label: 'inativos' },
            ],
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: '',
            column: 'descricao',
            order: 'asc',
            isSaving: false,
            delete: null,
            showModalAssociacao: false,
            //permissoes relativas à exibição dos botões
            permissaoVincular: false,
            permissaoCadastrar: false,

            abrev: this.$route.meta.contexto.slice(0, 3),
            isVenda: this.$route.meta.contexto == 'vendas',
            isAgro: this.$route.meta.contexto == 'agro',
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        // permissão da aba dessa página
        this.permissao = this.hasPermissionAccess('agro', 'agro-cadastros', 'agro-ocorrencia');

        // verificar permissão da página de produto para controlar o botão de adicionar
        if (this.isAgro) {
            this.abrev = this.$route.meta.contexto.slice(0, 4);
            this.permissao = this.hasPermissionAccess('agro', 'agro-cadastros', 'agro-ocorrencia');
        } else if (this.isVenda) {
            this.permissao = this.hasPermissionAccess('vendas', 'crm', 'ven-ocorrencia');
        }

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'ocorrencia' },
            });
        } else {
            this.carregarDados();
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        }
        // retirar && false quando tiver página de produto
        this.permissaoVincular = this.permissao.create && !this.assIntegracao;
        this.permissaoCadastrar = this.permissaoProduto.create && !this.produtoIntegracao && false;
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            let params = [this.queryFilter != '' ? this.queryFilter : '.*', this.$route.params.id];

            this.service
                .findAll(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacao.id,
                    this.abrev,
                    params
                )
                .then(this.mapItems)
                .then((value) => {
                    this.assocorrenciaproduto = value;
                    this.isEmpty = this.assocorrenciaproduto.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os usuários!');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    id: m.idagro_assocorrenciaproduto,
                    codigo: m.produto.idprodutoerp,
                    produto: m.produto.descricao,
                    familia: m.produto.produtoFamilia.descricao
                        ? m.produto.produtoFamilia.descricao
                        : '---',
                    situacao: m.situacao,
                    excluir: 'excluir',
                };
            });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSituacaoChanged(val) {
            this.situacao = val
                ? this.situacoes.filter((v) => v.id == val.id)[0]
                : this.situacoes[0];
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.situacao == 1
                        ? 'msg-confirmacao-desativacao-ass-n'
                        : 'msg-confirmacao-reativacao-ass-n', 
                    { n: row['produto'] }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.situacao == 1
                    ? 'msg-sucesso-ao-reativar-associacao-produto'
                    : 'msg-sucesso-ao-desativar-associacao-produto';

            let tempAss = {
                idagro_assocorrenciaproduto: this.delete.id,
                situacao: this.delete.situacao == 1 ? 0 : 1,
            };

            this.isLoading = true;

            this.service
                .updateSituacao(tempAss)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess =
                            r.content.situacao == 1
                                ? 'msg-sucesso-ao-reativar-associacao-produto'
                                : 'msg-sucesso-ao-desativar-associacao-produto';
                        this.$root.showMessage('success', tempSuccess);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        showModalVincular() {
            this.showModalAssociacao = !this.showModalAssociacao;
        },
        fecharModal() {
            this.showModalAssociacao = false;
            this.carregarDados();
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-produto {
    height: 100%;

    .situacao-select {
        div {
            height: 40px;
        }
    }

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .search-bar {
            padding-bottom: 0.4rem;
        }

        .situacao-select {
            width: 100%;
            padding-bottom: 0.8rem;
        }

        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>
